<template>
    <div class="fee-calc-global">
        <!-- Banner is being called on the top level because it exceeds the "main" size of the applicaiton and serves as a frame/header/banner -->
        <Banner/>
        <div class="container">
            <!-- Outputs what the current route is pointing to -->
            <keep-alive>
            <router-view></router-view>
            </keep-alive>
        </div>
        <PageFooter/>
    </div>
</template>

<script>

import Banner from './application/banner.vue'

export default {
    components: {
        Banner,
    },
    created () {
        this.$store.dispatch('fetchChunks');
        this.$store.dispatch('fetchURLs');
    }
}
</script>

<style lang="scss">
    //imports boostrap, murdoch and the application styles
    // These are already imported in common.js (via layouts/custom)
    // @import '../sass/custom.scss';
    // @import '../../node_modules/bootstrap/scss/bootstrap.scss';
    // @import '../sass/murdoch.scss';
    // @import '../sass/font-awesome-webfonts.scss';
</style>
